<ng-container>
  <div *ngIf="enableLoader" id="loader"></div>
  <div class="d-none d-lg-block">
    <div *ngIf="!enableLoader" class="row display-list-grid border-0">
      <div class="options">
        <span class="display-as">{{ 'home.productHeader.Display' | cxTranslate }}</span>
        <img
          class="grid-icon"
          title="grid"
          [src]="gridSrc"
          (click)="viewGrid()"
        />
        <img
          class="list-icon"
          title="list"
          [src]="listSrc"
          (click)="viewList()"
        />
      </div>
    </div>
    <!-- <app-custom-header></app-custom-header> -->
    <div *ngIf="!enableLoader" class="menu-container">
      <div class="menu-wrapper">
        <div class="row" *ngIf="grid">
          <div class="w-100 ml-4 mr-4 mb-4" *ngIf="portsideMenus.length > 0">
            <h4 class="w-100 text-secondary">{{ 'home.portside' | cxTranslate }}</h4>
            <hr class="w-100 border-b"/>
          </div>
           <ng-container *ngFor="let menu of portsideMenus">
            <div class="col-sm-3">
              <div class="grid-card pointer" (click)="navigate(menu.route)">
                <div class="child-menu-container">
                  <div class="menu-header">
                    <div class="menu-icon">
                      <img
                        src="{{ menu.menuIcon }}"
                        alt="{{ menu.title }}"
                      />
                    </div>
                    <div class="menu-title">
                      {{
                        menuTranslation(
                          "home.navigationMenus",
                          menu.title,
                          "displayTitle"
                        ) | cxTranslate
                      }} - {{
                        menuTranslation(
                          "home.navigationMenus",
                          menu.title,
                          "subItems.portside.items." + menu.type + ".displayTitle"
                        ) | cxTranslate
                      }}
                    </div>
                  </div>
                  <div class="menu-content">
                    {{
                      menuTranslation(
                        "home.navigationMenus",
                        menu.title,
                        "subItems.portside.items." + menu.type + ".description"
                      ) | cxTranslate
                    }}
                  </div>

                  <div class="menu-view-link">
                    <a [routerLink]="[menu.route]">{{
                      menuTranslation(
                        "home.navigationMenus",
                        menu.title,
                        "subItems.portside.items." + menu.type + ".ctaLink"
                      ) | cxTranslate
                    }}</a>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
          <div class="w-100 ml-4 mr-4 mb-4" *ngIf="bondedwarehouseMenus.length > 0">
            <h4 class="w-100 text-secondary">{{ 'home.bondedWarehouse' | cxTranslate }}</h4>
            <hr class="w-100 border-b"/>
          </div>
          <ng-container *ngFor="let menu of bondedwarehouseMenus">
            <div class="col-sm-3">
              <div class="grid-card pointer" (click)="navigate(menu.route)">
                <div class="child-menu-container">
                  <div class="menu-header">
                    <div class="menu-icon">
                      <img
                        src="{{ menu.menuIcon }}"
                        alt="{{ menu.title }}"
                      />
                    </div>
                    <div class="menu-title">
                      {{
                        menuTranslation(
                          "home.navigationMenus",
                          menu.title,
                          "displayTitle"
                        ) | cxTranslate
                      }} - {{
                        menuTranslation(
                          "home.navigationMenus",
                          menu.title,
                          "subItems.bondedwarehouse.items." + menu.type + ".displayTitle"
                        ) | cxTranslate
                      }}
                    </div>
                  </div>
                  <div class="menu-content">
                    {{
                      menuTranslation(
                        "home.navigationMenus",
                        menu.title,
                        "subItems.bondedwarehouse.items." + menu.type + ".description"
                      ) | cxTranslate
                    }}
                  </div>

                  <div class="menu-view-link">
                    <a [routerLink]="[menu.route]">{{
                      menuTranslation(
                        "home.navigationMenus",
                        menu.title,
                        "subItems.bondedwarehouse.items." + menu.type + ".ctaLink"
                      ) | cxTranslate
                    }}</a>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
          <div class="w-100 ml-4 mr-4 mb-4" *ngIf="adminMenus.length > 0 && portsideMenus.length !== 0 && bondedwarehouseMenus.length !== 0">
            <h4 class="w-100 text-secondary">{{ 'home.admin' | cxTranslate }}</h4>
            <hr class="w-100 border-b"/>
          </div>
          <ng-container *ngFor="let menu of adminMenus">
            <div class="col-sm-3">
              <div class="grid-card pointer" (click)="navigate(menu.route)">
                <div class="child-menu-container">
                  <div class="menu-header">
                    <div class="menu-icon">
                      <img
                        src="{{ menu.menuIcon }}"
                        alt="{{ menu.displayTitle }}"
                      />
                    </div>
                    <div class="menu-title">
                      {{
                        menuTranslation(
                          "home.navigationMenus",
                          menu.title,
                          "displayTitle"
                        ) | cxTranslate
                      }}
                    </div>
                  </div>
                  <div class="menu-content">
                    {{
                      menuTranslation(
                        "home.navigationMenus",
                        menu.title,
                        "description"
                      ) | cxTranslate
                    }}
                  </div>

                  <div class="menu-view-link">
                    <a [routerLink]="[menu.route]">{{
                      menuTranslation(
                        "home.navigationMenus",
                        menu.title,
                        "ctaLink"
                      ) | cxTranslate
                    }}</a>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
          <!-- <ng-container *ngFor="let menu of filteredMenus">
            <div class="col-sm-3">
              <div class="grid-card pointer" (click)="navigate(menu.route)">
                <div class="child-menu-container">
                  <div class="menu-header">
                    <div class="menu-icon">
                      <img
                        src="{{ menu.menuIcon }}"
                        alt="{{ menu.displayTitle }}"
                      />
                    </div>
                    <div class="menu-title">
                      {{
                        menuTranslation(
                          "home.navigationMenus",
                          menu.menuTitle,
                          "displayTitle"
                        ) | cxTranslate
                      }}
                    </div>
                  </div>
                  <div class="menu-content">
                    {{
                      menuTranslation(
                        "home.navigationMenus",
                        menu.menuTitle,
                        "description"
                      ) | cxTranslate
                    }}
                  </div>

                  <div class="menu-view-link">
                    <a [routerLink]="[menu.route]">{{
                      menuTranslation(
                        "home.navigationMenus",
                        menu.menuTitle,
                        "ctaLink"
                      ) | cxTranslate
                    }}</a>
                  </div>
                </div>
              </div>
            </div>
          </ng-container> -->
        </div>
        <div class="row" *ngIf="list">
           <div class="w-100 ml-4 mr-4 mb-4" *ngIf="portsideMenus.length > 0">
            <h4 class="w-100 text-secondary">{{ 'home.portside' | cxTranslate }}</h4>
            <hr class="w-100 border-b"/>
          </div>
           <ng-container *ngFor="let menu of portsideMenus">
            <div class="col-sm-12">
              <div class="list-card">
                <div class="child-list-container">
                  <div class="title-and-description">
                    <div class="list-menu-icon">
                      <img
                        src="{{ menu.menuIcon }}"
                        alt="{{ menu.title }}"
                      />
                    </div>
                    <div class="title">
                      <div class="list-menu-title">
                        {{
                        menuTranslation(
                          "home.navigationMenus",
                          menu.title,
                          "displayTitle"
                        ) | cxTranslate
                      }} - {{
                        menuTranslation(
                          "home.navigationMenus",
                          menu.title,
                          "subItems.portside.items." + menu.type + ".displayTitle"
                        ) | cxTranslate
                      }}
                      </div>
                      <div class="list-menu-content">
                        {{
                          menuTranslation(
                            "home.navigationMenus",
                            menu.title,
                             "subItems.portside.items." + menu.type + ".description"
                          ) | cxTranslate
                        }}
                      </div>
                    </div>
                  </div>

                  <div>
                    <button class="cta-btn" [routerLink]="[menu.route]">
                      {{
                        menuTranslation(
                          "home.navigationMenus",
                          menu.title,
                          "subItems.portside.items." + menu.type + ".ctaLink"
                        ) | cxTranslate
                      }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
           <div class="w-100 ml-4 mr-4 mb-4" *ngIf="bondedwarehouseMenus.length > 0">
            <h4 class="w-100 text-secondary">{{'home.bondedWarehouse' | cxTranslate}}</h4>
            <hr class="w-100 border-b"/>
          </div>
           <ng-container *ngFor="let menu of bondedwarehouseMenus">
            <div class="col-sm-12">
              <div class="list-card">
                <div class="child-list-container">
                  <div class="title-and-description">
                    <div class="list-menu-icon">
                      <img
                        src="{{ menu.menuIcon }}"
                        alt="{{ menu.title }}"
                      />
                    </div>
                    <div class="title">
                      <div class="list-menu-title">
                        {{
                        menuTranslation(
                          "home.navigationMenus",
                          menu.title,
                          "displayTitle"
                        ) | cxTranslate
                      }} - {{
                        menuTranslation(
                          "home.navigationMenus",
                          menu.title,
                          "subItems.bondedwarehouse.items." + menu.type + ".displayTitle"
                        ) | cxTranslate
                      }}
                      </div>
                      <div class="list-menu-content">
                        {{
                          menuTranslation(
                            "home.navigationMenus",
                            menu.title,
                             "subItems.bondedwarehouse.items." + menu.type + ".description"
                          ) | cxTranslate
                        }}
                      </div>
                    </div>
                  </div>

                  <div>
                    <button class="cta-btn" [routerLink]="[menu.route]"  [ngClass]="{'button-size': menu.type === 'inspection' || menu.type === 'screening'}">
                      {{
                        menuTranslation(
                          "home.navigationMenus",
                          menu.title,
                          "subItems.bondedwarehouse.items." + menu.type + ".ctaLink"
                        ) | cxTranslate
                      }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
           <div class="w-100 ml-4 mr-4 mb-4" *ngIf="adminMenus.length > 0 && portsideMenus.length !== 0 && bondedwarehouseMenus.length !== 0">
            <h4 class="w-100 text-secondary">{{'home.admin' | cxTranslate}}</h4>
            <hr class="w-100 border-b"/>
          </div>
          <ng-container *ngFor="let menu of adminMenus">
            <div class="col-sm-12">
              <div class="list-card">
                <div class="child-list-container">
                  <div class="title-and-description">
                    <div class="list-menu-icon">
                      <img
                        src="{{ menu.menuIcon }}"
                        alt="{{ menu.displayTitle }}"
                      />
                    </div>
                    <div class="title">
                      <div class="list-menu-title">
                        {{
                          menuTranslation(
                            "home.navigationMenus",
                            menu.title,
                            "displayTitle"
                          ) | cxTranslate
                        }}
                      </div>
                      <div class="list-menu-content">
                        {{
                          menuTranslation(
                            "home.navigationMenus",
                            menu.title,
                            "description"
                          ) | cxTranslate
                        }}
                      </div>
                    </div>
                  </div>

                  <div>
                    <button class="cta-btn" [routerLink]="[menu.route]">
                      {{
                        menuTranslation(
                          "home.navigationMenus",
                          menu.title,
                          "ctaLink"
                        ) | cxTranslate
                      }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
          <!-- <ng-container *ngFor="let menu of filteredMenus">
            <div class="col-sm-12">
              <div class="list-card">
                <div class="child-list-container">
                  <div class="title-and-description">
                    <div class="list-menu-icon">
                      <img
                        src="{{ menu.menuIcon }}"
                        alt="{{ menu.displayTitle }}"
                      />
                    </div>
                    <div class="title">
                      <div class="list-menu-title">
                        {{
                          menuTranslation(
                            "home.navigationMenus",
                            menu.menuTitle,
                            "displayTitle"
                          ) | cxTranslate
                        }}
                      </div>
                      <div class="list-menu-content">
                        {{
                          menuTranslation(
                            "home.navigationMenus",
                            menu.menuTitle,
                            "description"
                          ) | cxTranslate
                        }}
                      </div>
                    </div>
                  </div>

                  <div>
                    <button class="cta-btn" [routerLink]="[menu.route]">
                      {{
                        menuTranslation(
                          "home.navigationMenus",
                          menu.menuTitle,
                          "ctaLink"
                        ) | cxTranslate
                      }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </ng-container> -->
        </div>
      </div>
    </div>
  </div>
  <div class="d-lg-none">
    <div class="container bcontent mx-auto mobile-menu-container">
      <!-- Portside Section -->
      <div *ngIf="portsideMenus.length > 0" class="mobile-section-wrapper">
        <div class="mobile-section-header">
          <h5 class="mobile-section-title">{{'home.portside' | cxTranslate}}</h5>
        </div>
        <ng-container *ngFor="let menu of portsideMenus">
          <div class="mobile-menu-card pointer" (click)="navigate(menu.route)">
            <div class="mobile-icon-strip">
              <img [src]="menu.menuIcon" [alt]="menu.title" />
            </div>
            <div class="mobile-text-content">
              <div class="mobile-title">
                {{ (menuTranslation("home.navigationMenus", menu.title, "displayTitle") | cxTranslate)}}
                -
                {{ (menuTranslation("home.navigationMenus", menu.title, "subItems.portside.items." + menu.type + ".displayTitle") | cxTranslate)  }}
              </div>
              <div class="mobile-description">
                {{ (menuTranslation("home.navigationMenus", menu.title, "subItems.portside.items." + menu.type + ".description") | cxTranslate)  }}
              </div>
            </div>
            <div class="mobile-arrow" aria-hidden="true">
              <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M4 10a.5.5 0 0 1 .5-.5h5.793L8.146 7.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 10.5H4.5A.5.5 0 0 1 4 10" />
              </svg>
            </div>
          </div>
        </ng-container>
      </div>

      <!-- Bonded warehouse Section -->
      <div *ngIf="bondedwarehouseMenus.length > 0" class="mobile-section-wrapper">
        <div class="mobile-section-header">
          <h5 class="mobile-section-title">{{'home.bondedWarehouse' | cxTranslate}}</h5>
        </div>
        <ng-container *ngFor="let menu of bondedwarehouseMenus">
          <div class="mobile-menu-card pointer" (click)="navigate(menu.route)">
            <div class="mobile-icon-strip">
              <img [src]="menu.menuIcon" [alt]="menu.title" />
            </div>
            <div class="mobile-text-content">
              <div class="mobile-title">
                {{ (menuTranslation("home.navigationMenus", menu.title, "displayTitle") | cxTranslate)  }}
                -
                {{ (menuTranslation("home.navigationMenus", menu.title, "subItems.bondedwarehouse.items." + menu.type + ".displayTitle") | cxTranslate)  }}
              </div>
              <div class="mobile-description">
                {{ (menuTranslation("home.navigationMenus", menu.title, "subItems.bondedwarehouse.items." + menu.type + ".description") | cxTranslate)  }}
              </div>
            </div>
            <div class="mobile-arrow" aria-hidden="true">
              <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M4 10a.5.5 0 0 1 .5-.5h5.793L8.146 7.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 10.5H4.5A.5.5 0 0 1 4 10" />
              </svg>
            </div>
          </div>
        </ng-container>
      </div>

      <!-- Admin Section -->
      <div *ngIf="adminMenus.length > 0 && portsideMenus.length !== 0 && bondedwarehouseMenus.length !== 0" class="mobile-section-wrapper">
        <div class="mobile-section-header">
          <h5 class="mobile-section-title">{{'home.admin' | cxTranslate}}</h5>
        </div>
        <ng-container *ngFor="let menu of adminMenus">
          <div class="mobile-menu-card pointer" (click)="navigate(menu.route)">
            <div class="mobile-icon-strip">
              <img [src]="menu.menuIcon " [alt]="menu.title" />
            </div>
            <div class="mobile-text-content">
              <div class="mobile-title">
                {{ (menuTranslation("home.navigationMenus", menu.title, "displayTitle") | cxTranslate)  }}
              </div>
              <div class="mobile-description">
                {{ (menuTranslation("home.navigationMenus", menu.title, "description") | cxTranslate) }}
              </div>
            </div>
            <div class="mobile-arrow" aria-hidden="true">
              <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M4 10a.5.5 0 0 1 .5-.5h5.793L8.146 7.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 10.5H4.5A.5.5 0 0 1 4 10" />
              </svg>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</ng-container>
